(() => {
  if (window.featuredCollectionPagedInitialized) return;
  window.featuredCollectionPagedInitialized = true;

  const getPagedCollectionParts = (carousel) => {
    const track = carousel.querySelector('[data-featured-paged-track]');
    const pages = Array.from(carousel.querySelectorAll('[data-featured-paged-page]'));
    const prevButton = carousel.querySelector('[data-featured-paged-prev]');
    const nextButton = carousel.querySelector('[data-featured-paged-next]');

    return { track, pages, prevButton, nextButton };
  };

  const updatePagedCollection = (carousel) => {
    const { track, pages, prevButton, nextButton } = getPagedCollectionParts(carousel);
    if (!track || pages.length < 2 || !prevButton || !nextButton) return;

    const currentPage = Number(carousel.dataset.pagedCollectionPage || 0);
    track.style.transform = `translateX(-${currentPage * 100}%)`;
    prevButton.disabled = currentPage === 0;
    nextButton.disabled = currentPage === pages.length - 1;
  };

  const goToPagedCollectionPage = (carousel, page) => {
    const { pages } = getPagedCollectionParts(carousel);
    const nextPage = Math.min(Math.max(page, 0), pages.length - 1);

    carousel.dataset.pagedCollectionPage = String(nextPage);
    updatePagedCollection(carousel);
  };

  const movePagedCollection = (carousel, direction) => {
    const currentPage = Number(carousel.dataset.pagedCollectionPage || 0);
    goToPagedCollectionPage(carousel, currentPage + direction);
  };

  const bindPagedCollectionSwipe = (carousel) => {
    const viewport = carousel.querySelector('[data-featured-paged-viewport]');
    if (!viewport || viewport.dataset.pagedCollectionSwipeReady === 'true') return;

    viewport.dataset.pagedCollectionSwipeReady = 'true';
    let startX = 0;
    let startY = 0;
    let isMoving = false;
    let isSettling = false;

    const handleSwipe = (endX, endY, initialX = startX, initialY = startY) => {
      if (isSettling) return;

      const deltaX = endX - initialX;
      const deltaY = endY - initialY;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

      movePagedCollection(carousel, deltaX < 0 ? 1 : -1);
      isSettling = true;
      window.setTimeout(() => {
        isSettling = false;
      }, 380);
    };

    if ('PointerEvent' in window) {
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        startX = event.clientX;
        startY = event.clientY;
        isMoving = true;
        viewport.setPointerCapture?.(event.pointerId);
      });

      viewport.addEventListener('pointerup', (event) => {
        if (!isMoving || (event.pointerType !== 'touch' && event.pointerType !== 'pen')) return;
        isMoving = false;
        handleSwipe(event.clientX, event.clientY);
      });

      viewport.addEventListener('pointercancel', () => {
        isMoving = false;
      });

      return;
    }

    viewport.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;

        handleSwipe(touch.clientX, touch.clientY);
      },
      { passive: true }
    );
  };

  const initPagedCollection = (carousel) => {
    if (!carousel || carousel.dataset.pagedCollectionReady === 'true') return;

    const { track, pages, prevButton, nextButton } = getPagedCollectionParts(carousel);
    if (!track || pages.length < 2 || !prevButton || !nextButton) return;

    carousel.dataset.pagedCollectionReady = 'true';
    carousel.dataset.pagedCollectionPage = '0';
    bindPagedCollectionSwipe(carousel);
    updatePagedCollection(carousel);
  };

  const initAllPagedCollections = (root = document) => {
    root.querySelectorAll('[data-featured-paged-carousel]').forEach((carousel) => {
      initPagedCollection(carousel);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAllPagedCollections());
  document.addEventListener('shopify:section:load', (event) => initAllPagedCollections(event.target));
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-featured-paged-prev], [data-featured-paged-next]');
    if (!button) return;

    const carousel = button.closest('[data-featured-paged-carousel]');
    if (!carousel) return;

    initPagedCollection(carousel);

    const direction = button.matches('[data-featured-paged-next]') ? 1 : -1;
    movePagedCollection(carousel, direction);
  });
})();
